import React, { Component } from 'react';
import { connect } from 'react-redux';
import { GreyButton } from '../../../../../GreyButton';
import { PrimaryButton } from '../../../../../PrimaryButton';
import { Modal } from '../../../../../Modal';
import './UserManagementModal.css';
import { Notification } from '../../../../../Notification';
import { BuildingUserActions } from '../../../../../../store';

export interface Props {
  operation: string;
  user: string;
  successMessage: string;
  onConfirm(): void;
  onCancel(): void;
  onClose(): void;
  clearSuccessMessage(): void;
}

export class UserManagementModal extends Component<Props, never> {
  onClose = () => {
    const { onClose, clearSuccessMessage } = this.props;

    clearSuccessMessage();
    onClose();
  };

  render() {
    const { operation, user, onCancel, onConfirm, successMessage } = this.props;

    if (!operation) {
      const modalMessage = 'You do not have permission to perform this action';

      return (
        <Modal>
          <div className="user-management-modal-overlay">
            <div className="user-management-modal">
              <div className="user-management-modal__notification-wrapper">
                <Notification type="error" message={modalMessage} />
              </div>
              <div className="user-management-modal__buttons">
                <div className="user-management-modal__button">
                  <PrimaryButton label="Close" onClick={onCancel} fullWidth={true} />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      );
    }

    let operationText;
    switch (operation) {
      case 'resendInvite':
        operationText = 'resend the invite';
        break;
      case 'revokeAccess':
        operationText = 'revoke the access';
        break;
      case 'resetPassword':
        operationText = 'reset the password';
        break;
      case 'addPermission':
        operationText = 'add a permission';
        break;
      case 'removePermission':
        operationText = 'remove a permission';
        break;
      default:
        operationText = '';
    }
    const message = `Warning: You are about to ${operationText} for ${user}, are you sure you want to do this?`;

    return (
      <Modal>
        <div className="user-management-modal-overlay">
          {successMessage ? (
            <div className="user-management-modal">
              <div className="user-management-modal__notification-wrapper">
                <Notification type="success" message={successMessage} />
              </div>
              <div className="user-management-modal__buttons">
                <div className="user-management-modal__button">
                  <PrimaryButton label="Close" onClick={this.onClose} fullWidth={true} />
                </div>
              </div>
            </div>
          ) : (
            <div className="user-management-modal">
              <div className="user-management-modal__notification-wrapper">
                <Notification type="warning" message={message} />
              </div>
              <div className="user-management-modal__buttons">
                <div className="user-management-modal__button user-management-modal__button-cancel">
                  <GreyButton label="Cancel" onClick={onCancel} fullWidth={true} />
                </div>
                <div className="user-management-modal__button">
                  <PrimaryButton label="Confirm" onClick={onConfirm} fullWidth={true} />
                </div>
              </div>
            </div>
          )}
        </div>
      </Modal>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    successMessage: state.buildingUserReducer.successMessage,
  };
}

const mapDispatchToProps = {
  clearSuccessMessage: BuildingUserActions.clearUserActionSuccess,
};

export const ConnectedUserManagementModal = connect(mapStateToProps, mapDispatchToProps)(UserManagementModal);
